import { Box, Typography } from "@mui/material";
import { SubscriptionContext } from "contexts/Subscription";
import { useContext } from "react";
import { Plans } from "schemas/payments";

import { useSubscription } from "utils/useSubscription";

import styles from "./styles";

interface Props {
  plan: Plans;
}

const PlansPrice = ({ plan }: Props) => {
  const { subscription, plans } = useContext(SubscriptionContext);
  const { getPrice } = useSubscription();

  if (!plans) return <></>;

  const originalPrice = plans[plan]?.price;
  const discountedPrice = getPrice(plan) || originalPrice;
  const hasDiscounted = originalPrice > discountedPrice;

  return (
    <>
      <Box sx={hasDiscounted ? styles.strike : {}}>
        <Box>${originalPrice}/mo</Box>
      </Box>
      {hasDiscounted && <Box>${getPrice(plan)}/mo</Box>}
      {subscription?.bannerPromoCode?.dateEnding && (
        <Typography sx={{ color: "#d95e58" }}>
          until {subscription?.bannerPromoCode?.dateEnding}
        </Typography>
      )}
    </>
  );
};

export default PlansPrice;
